import './bootstrap';
import './calendar';

import 'jquery-ui/dist/jquery-ui.js';
import Selectize from '@selectize/selectize';

import Utils from './utils';
import MyCalendar from './calendar';

import.meta.glob([
    '../images/**',
]);

$.fn.activateMultiPanel = function(active) {
    $(this).find('.child').each((index, el) => {
        el = $(el);

        if (el.hasClass(active)) {
            el.prop('hidden', false);
        }
        else {
            el.prop('hidden', true);
        }
    });
}

/*
    Utilizzato per settare il valore del widget di selezione dello specialista.
    Si assume che sia già stato attivato il sotto-pannello giusto (con
    activateMultiPanel()), questo popola il relativo contenuto con gli ID
    presenti nell'array "values" passato come parametro
*/
$.fn.selectMultiPanel = function(values) {
    let active = $(this).find('.child').filter(':not([hidden])');
    let single = active.find('select');
    if (single.length) {
        single.val(values[0]);
    }
    else {
        active.find('input[type=checkbox]').each((index, node) => {
            let check = $(node);
            let val = parseInt(check.val());
            check.prop('checked', values.includes(val));
        });
    }
}

function populateSelectedPatient(data, container)
{
    /*
        Quando il button di selezione del paziente viene
        attivato, lo identifico con la classe .enabled e
        poi intervengo solo su di esso. Questo per
        gestire molteplici pulsanti nella stessa pagina,
        e interagire solo con quello effettivamente
        selezionato di volta in volta
    */
    const selector = $('.patient-selector.enabled');
    selector.text(data.label);
    selector.next('input[type=hidden]').val(data.id);

    if (selector.hasClass('only-select') == false) {
        let form = selector.closest('form');

        let date = form.find('input[name=datetime]');
        if (date.val() == '') {
            date.val(data.preferred_datetime);

            form.find('input[name=room]').val(data.preferred_room);
        }

        let activity = form.find('select[name=activity]');
        activity.find('option').each((index, opt) => {
            let o = $(opt);
            let val = o.val();
            o.prop('disabled', data.preferred_activities.includes(Number.parseInt(val)) == false);
        });

        if (data.preferred_activities.includes(data.current_therapy.activity)) {
            activity.val(data.current_therapy.activity).change();
        }
        else {
            let first = activity.find('option').filter(':not(:disabled)').first();
            activity.val(first.val()).change();
        }

        form.find('input[name=cost]').val(data.current_therapy.cost).change();
        form.find('.specialist-select').selectMultiPanel(data.current_therapy.therapists);
    }

    selector.siblings('.patient-creator').remove();

    const details = selector.siblings('.patient-selector-details');
    details.empty().append(data.formatted_details);

    if (container.hasClass('modal')) {
        container.modal('hide');
    }
    else {
        container.closest('.modal').modal('hide');
    }
}

function fetchSelectedPatient(row, container)
{
    return new Promise((resolve) => {
        const url = row.attr('data-patient-url');

        if (url) {
            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'JSON',
                success: (data) => {
                    populateSelectedPatient(data, container);
                    resolve();
                }
            });
        }
    });
}

function formatFrequency(type, date, venue)
{
    let formatted_frequency = '';

    if (type == 'none') {
        formatted_frequency = 'Nessun appuntamento pianificato.';
    }
    else {
        let frequency = type == 'weekly' ? 'settimana' : 'due settimane';
        if (date) {
            let new_fulldate = new Intl.DateTimeFormat("it-IT", {dateStyle: "short"}).format(date);
            let new_day = new Intl.DateTimeFormat("it-IT", {weekday: "long"}).format(date);
            let new_hour = new Intl.DateTimeFormat("it-IT", {hour: "numeric", minute: "numeric"}).format(date);
            formatted_frequency = 'Dal ' + new_fulldate + ', appuntamenti ogni ' + frequency + ' il ' + new_day + ' alle ore ' + new_hour + ' a ' + venue + '.';
        }
        else {
            formatted_frequency = 'Appuntamenti ogni ' + frequency + ' a ' + venue + '.';
        }
    }

    return formatted_frequency;
}

function formatFrequencyChangeSummary(node)
{
    let alert = node.siblings('.frequency-summary');
    if (alert.length > 0) {
        let patientname = alert.attr('data-patient-name');
        let venue = alert.attr('data-session-venue');
        let originaltype = node.find('.btn-group').attr('data-original-frequency');
        let type = node.find('.btn-group').find(':checked').val();

        const fulldate = node.find('[name=full_start]');
        let originaldate = Date.parse(fulldate.attr('data-original-date'));
        let date = Date.parse(fulldate.val());

        if (originaltype != type || ((Number.isNaN(originaldate) == false || Number.isNaN(date) == false) && originaldate != date)) {
            alert.prop('hidden', false);
            const current_frequency = formatFrequency(originaltype, originaldate, venue);
            const new_frequency = formatFrequency(type, date, venue);
            alert.html('<p>Attualmente ' + patientname + ' ha la seguente pianificazione:<br>' + current_frequency + '</p><p>Questa è la nuova pianificazione che hai scelto:<br>' + new_frequency + '</p>');
        }
        else {
            alert.prop('hidden', true);
        }
    }
}

$(document).ready(function() {
    Utils.j().init({
        fixBootstrap: ['Modal', 'Popover', 'Collapse'],
        initFunction: function(container) {
            /*
                Interazione dinamica su selezione tipo di attività: abilita la
                selezione singola/multipla dei terapeuti, ed il costo
            */
            $('.activity-select', container).each((index, el) => {
                let sel = $(el);

                sel.change((e) => {
                    let changed = $(e.currentTarget);
                    let form = changed.closest('form');
                    let selected = changed.val();
                    let specialist_select = 'one';
                    let cost = 0;

                    changed.attr('data-activity-map').split(';').forEach((mapped) => {
                        let tokens = mapped.split('|');
                        if (tokens[0] == selected) {
                            specialist_select = tokens[1];
                            cost = tokens[2];
                            return false;
                        }
                    });

                    $('.specialist-select', form).activateMultiPanel(specialist_select);

                    if (form.hasClass('editing') == false) {
                        $('.cost-select', form).val(cost).change();
                    }
                });

                sel.change();
            });

            /*
                Interazione dinamica per la selezione delle fonti dei pazienti.
                Dopo aver predisposto il listener per l'evento "change", forzo
                l'evento stesso in modo che sia immediatamente applicato
            */
            $('.source-select', container).change((e) => {
                let sel = $(e.currentTarget);
                let source = sel.find('option:selected').attr('data-source-type');
                sel.siblings('.multi-panel').activateMultiPanel(source);
            }).change();

            /*
                Autocompletamento
            */
            $('.autocomplete', container).each((index, el) => {
                let input = $(el);
                let url = input.attr('data-autocomplete-url');

                let selectable = [];
                let selected = input.attr('data-pre-selected');
                if (selected) {
                    selected = selected.split('|');
                    selectable.push({
                        id: selected[0],
                        text: selected[1],
                    });
                }

                input.selectize({
                    valueField: 'id',
                    labelField: 'text',
                    options: selectable,
                    items: selectable.map((i) => i.id),
                    mode: 'single',
                    closeAfterSelect: true,
                    setFirstOptionActive: true,
                    load: function(query, callback) {
                        if (query.length == 0) {
                            return callback();
                        }

                        $.ajax({
                            url: url,
                            method: 'GET',
                            dataType: 'json',
                            data: {
                                term: query,
                            },
                            error: function() {
                                callback();
                            },
                            success: function(res) {
                                callback(res);
                            }
                        });
                    }
                });
            });

            $('.void_date', container).click((e) => {
                e.preventDefault();
                $(e.currentTarget).closest('.input-group').find('input').val('').change();
            });

            /*
                Interazione dinamica su selezione tipo utente: modifica la
                selezione del tipo attività
            */
            $('.user-type-select', container).each((index, el) => {
                let sel = $(el);

                sel.change((e) => {
                    let changed = $(e.currentTarget);
                    let form = changed.closest('form');
                    let selected = changed.val();
                    let activity = 0;

                    changed.attr('data-activity-map').split(';').forEach((mapped) => {
                        let tokens = mapped.split('|');
                        if (tokens[0] == selected) {
                            activity = tokens[1];
                            return false;
                        }
                    });

                    $('.activity-select', form).val(activity).change();
                });

                sel.change();
            });

            $('#current-page-filter').change((e) => {
                $(e.currentTarget).submit();
            });

            $('.inline-checks-selector', container).on('click', '.select-all', (e) => {
                $(e.currentTarget).closest('label').closest('div').find('input[type=checkbox]').prop('checked', true);
            }).on('click', '.select-none', (e) => {
                $(e.currentTarget).closest('label').closest('div').find('input[type=checkbox]').prop('checked', false);
            });

            $('.frequency-select', container).each((index, node) => {
                node = $(node);

                let datewrap = node.find('input[type=datetime-local]').closest('.mb-3');
                let originaltype = node.find('.btn-group').attr('data-original-frequency');

                node.find('input:radio').change((e) => {
                    let selected = $(e.currentTarget).val();
                    datewrap.prop('hidden', selected == 'none');

                    let summarywrap = $('.change-frequency-summary');
                    summarywrap.prop('hidden', selected == originaltype);

                    formatFrequencyChangeSummary(node);
                }).filter(':checked').change();

                node.find('input[type=datetime-local]').change((e) => {
                    formatFrequencyChangeSummary(node);
                });
            });

            /*
                Pagina creazione/modifica appuntamento
            */

            $('.session-editor', container).each((index, node) => {
                let editor = $(node);

                /*
                    Per nascondere la selezione della sede quando si sceglie una
                    sessione completamente remota
                */
                editor.find('select[name=mode]').on('change', (e) => {
                    let mode = $(e.currentTarget);
                    let room = editor.find('select[name=room]').closest('div');
                    room.prop('hidden', mode.val() == 'remote');
                }).change();

                /*
                    Blocca il salvataggio di un nuovo appuntamento se non viene
                    specificato un paziente
                */
                editor.find('.session-form').on('submit', (e) => {
                    let form = $(e.currentTarget);
                    let user_id = form.find('input[name=user_id]').val();
                    if (user_id == '') {
                        alert('Non hai selezionato un paziente');
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            });

            /*
                Modale ricerca e selezione pazienti
            */

            $('.patient-selector', container).each(async (index, node) => {
                const sel = $(node);

                sel.click((e) => {
                    $('.patient-selector.enabled').removeClass('enabled');
                    $(e.currentTarget).addClass('enabled');
                });

                sel.addClass('enabled');
                await fetchSelectedPatient(sel, container);
                sel.removeClass('enabled');
            });

            $('.patient-creator', container).click((e) => {
                $('.patient-selector.enabled').removeClass('enabled');
                $(e.currentTarget).siblings('.patient-selector').addClass('enabled');
            });

            if (container.attr('id') == 'patient-search') {
                container.on('click', '[data-patient-url]', (e) => {
                    e.preventDefault();
                    let row = $(e.currentTarget);
                    fetchSelectedPatient(row, container);
                }).on('hide.bs.modal', () => {
                    $('.patient-selector.enabled').removeClass('enabled');
                });
            }

            $('.show-by-select', container).each((index, node) => {
                let collapse = $(node);
                let linked = collapse.attr('data-select-target');
                let select = collapse.closest('form').find(linked);
                let trigger = collapse.attr('data-select-required-values');

                select.change((e) => {
                    let selected = $(e.currentTarget).val();
                    if (selected == trigger) {
                        collapse.collapse('show');
                    }
                    else {
                        collapse.collapse('hide');
                    }
                });

                let skip = collapse.attr('data-select-skip-first');
                if (!skip) {
                    select.change();
                }
            });

            $('form', container).submit((e) => {
                $(e.currentTarget).find('[hidden]').remove();
            });
        },
        dynamicFunctions: {
            newSlimPatient: (form, data) => {
                populateSelectedPatient(data, form);

                /*
                    In alcune circostanze (in particolare: nel widget per creare
                    relazioni tra pazienti) nascondo un hidden
                    name=just_created_users con cui tengo traccia degli utenti
                    creati in modo contestuale.
                    Questo viene poi recuperato in
                    PatientController::storeRelations() per costruire
                    implicitamente delle relazioni addizionali
                */
                let tracker = $('[name=just_created_users]');
                if (tracker.length) {
                    let tracked = tracker.val().split(',');
                    tracked.push(data.id);
                    tracker.val(tracked.join(','));
                }
            },
            reloadCalendar: (form, data) => {
                MyCalendar.refetch();
            },
            evaluateSessionFrequency: (form, data) => {
                if (data.do == 'redirect') {
                    window.location.href = data.redirect;
                }
                else {
                    const d = $(data.modal);
                    Utils.j().initElements(d);
                    d.addClass('delete-on-close').modal('show');
                }
            },
        }
    });

    MyCalendar.init();
});
